module.exports = __webpack_public_path__ + "img/icon_setting_gear.cbd8c80b.svg";